// extracted by mini-css-extract-plugin
export var button = "_du-4";
export var hasDarkBackground = "_du-7";
export var hasLightBackground = "_du-6";
export var iconWrapper = "_du-0";
export var large = "_du-2";
export var medium = "_du-1";
export var small = "_du-5";
export var xsmall = "_du-3";